var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "md-tabs",
        { staticClass: "md-transparent" },
        _vm._l(_vm.wizardKeys, function(config, idx) {
          return _c(
            "md-tab",
            {
              key: "key-" + idx,
              attrs: { id: "tab-" + idx, "md-label": config[1] + "s" }
            },
            [
              _c("configuration-editor", {
                attrs: {
                  configKey: config[0],
                  columnTitle: config[1],
                  inputType: config[2]
                }
              })
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-344c0381", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-344c0381","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfigurationWizard.vue
// module id = null
// module chunks = 